window.addEventListener("DOMContentLoaded", function () {
  //handle no discount field and cart content yet
  if (!document.querySelector(".input-discount")) {
    notifyDiscount();
    analyzeCart(cartJSON);
  }
});

(() => {
  async function removeGift(cart) {
    let giftThreshold =
      document.querySelector(".gamification").dataset.thresholdGift;
    let giftProducts =
      document.querySelector(".gamification").dataset.giftProducts;
    const cartContent = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();

    let giftProductsInCart = cartContent.items.filter((item) => {
      return giftProducts.split(",").indexOf(item.product_id.toString()) > -1;
    });
    console.log(
      "debug cartContent ",
      cartContent,
      " giftProductsInCart ",
      giftProductsInCart
    );

    if (
      parseInt(cartContent.total_price) < parseInt(giftThreshold) &&
      giftProductsInCart.length > 0
    ) {
      //remove gift
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: giftProductsInCart[0].key,
            quantity: 0,
            sections: sectionsToBundle,
          }),
        })
      ).json();
      if (document.querySelector("line-item:has(.gift-badge-wrapper)")) {
        document.querySelector(
          "line-item:has(.gift-badge-wrapper)"
        ).style.display = "none";
      }
    }
  }

  //remove gifts
  const cartCheckEvents = ["cart:change", "cart:refresh", "DOMContentLoaded"];
  cartCheckEvents.forEach((event) => {
    document.addEventListener(event, async function (e) {
      console.log("DEBUG event ", event);
      if (document.querySelector(".gamification")) {
        removeGift(null);
      }
    });
  });
  // document.addEventListener('cart:change', async function (e) {
  //     if (document.querySelector('.gamification')) {
  //         removeGift(e.detail.cart);
  //     }
  // });
  // document.addEventListener('DOMContentLoaded', async function (e) {
  //     if (document.querySelector('.gamification')) {
  //         removeGift(cartJSON);
  //     }
  // });
})();

function initShopTheLookCarousel() {
  // shop the look carousel
  const carouselEl = document.querySelector(".shop-the-look-v3__carousel");
  if (!carouselEl) return;

  // Initialize Flickity manually for better control
  const flkty = new Flickity(
    carouselEl,
    JSON.parse(carouselEl.dataset.flickity)
  );

  if (flkty) {
    // Update carousel classes based on selected slide
    function updateCarouselClass() {
      const selectedSlide = carouselEl.querySelector(
        ".shop-the-look-v3.is-selected"
      );
      if (selectedSlide) {
        const numProducts = selectedSlide.getAttribute(
          "data-number-of-products"
        );

        // Remove old classes
        carouselEl.classList.remove(
          "has-2-products",
          "has-3-products",
          "has-4-products"
        );

        // Add new class
        if (numProducts === "3") {
          carouselEl.classList.add("has-3-products");
        } else if (numProducts === "4") {
          carouselEl.classList.add("has-4-products");
        } else {
          carouselEl.classList.add("has-2-products");
        }
      }
    }

    // Update on slide change
    flkty.on("change", updateCarouselClass);

    // Initial update
    updateCarouselClass();

    // Safari fix: Force resize after initialization
    setTimeout(function () {
      flkty.resize();
    }, 100);

    // Additional Safari fix: Force reflow on image load
    const images = carouselEl.querySelectorAll("img");
    let loadedImages = 0;
    images.forEach(function (img) {
      if (img.complete) {
        loadedImages++;
      } else {
        img.addEventListener("load", function () {
          loadedImages++;
          if (loadedImages === images.length) {
            flkty.resize();
          }
        });
      }
    });

    if (loadedImages === images.length) {
      flkty.resize();
    }
  }
}

// handle collection nav on HOME pages when gender content switch
// function initCollectionNav() {
//   if (document.querySelector(".collection-nav-wrapper")) {
//     document.querySelectorAll(".collection-nav-wrapper").forEach((sldier) => {
//       new Flickity(sldier, {
//         prevNextButtons: false,
//         contain: true,
//         pageDots: false,
//         freeScroll: true,
//         cellAlign: "center",
//         initialIndex: "1",
//         draggable: true,
//       });
//     });
//   }
// }

// window.addEventListener("resize", function () {
//   console.log("DEBUG resize event");
//   initCollectionNav();
// });
// Initialize after DOM and Flickity are ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".shop-the-look-v3__carousel")) {
      setTimeout(initShopTheLookCarousel, 50);
    }
  });
} else {
  if (document.querySelector(".shop-the-look-v3__carousel")) {
    //check if carousel exists
    setTimeout(initShopTheLookCarousel, 50);
  }
}

// handle collection nav on HOME pages when gender content switch
window.addEventListener("genderChange", function () {
  console.log("DEBUG genderChange event");
  if (document.querySelector(".collection-nav-wrapper")) {
    new Flickity(".collection-nav-wrapper", {
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      freeScroll: true,
      cellAlign: "center",
      initialIndex: "1",
    });
  }
});

//bunlde discount check
(async function () {
  let activeBundleInCart = false;
  async function doubleDiscountCheckInCart() {
    try {
      // 1. Fetch cart.js
      const cart = await (await fetch("/cart.js")).json();

      // 2. Check line items if there is an item with property _bundle_discount
      let updatedCart = null;
      for (let item of cart.items) {
        // console.log('DEBUG item ', item);
        if (
          item.properties &&
          typeof item.properties._bundle_discount !== "undefined"
        ) {
          activeBundleInCart = true;
          // console.log('DEBUG item.properties._bundle_discount ', item.properties._bundle_discount);
          // 3. If discount is the same as window.themeVariables.bundle_discount (without (%)), return
          let cartDiscount = item.properties._bundle_discount || "";
          let currentDiscount =
            window.themeVariables && window.themeVariables.bundle_discount
              ? window.themeVariables.bundle_discount
                  .toString()
                  .replace("%", "")
                  .trim()
              : "";

          // if (cartDiscount === currentDiscount) {
          //   return; // discount matches, nothing to do
          // }

          // console.log('DEBUG cartDiscount ', cartDiscount, ' currentDiscount ', currentDiscount);
          // 4. check if it has _bundle_handle
          if (
            typeof item.properties._bundle_handle !== "undefined" &&
            item.properties._bundle_handle
          ) {
            let bundleHandle = item.properties._bundle_handle;
            // console.log('DEBUG bundleHandle ', bundleHandle);
            // 5. Fetch /products/_bundle_handle
            const productResp = await fetch(`/products/${bundleHandle}.js`);
            if (!productResp.ok) continue;
            const bundleProduct = await productResp.json();

            // 6. Check if the bundle product tags contain tag {_bundle_discount}-percent-bundle
            // Need to find any tag like '10-percent-bundle' and extract number before '-percent-bundle'
            let bundleTagMatch = null;
            if (bundleProduct.tags && Array.isArray(bundleProduct.tags)) {
              for (let tag of bundleProduct.tags) {
                console.log("DEBUG tag ", tag);
                if (tag && /(\d+)-percent-bundle/.test(tag)) {
                  let tagDiscount = tag
                    .replace("-percent-bundle", "")
                    .replace("%", "")
                    .trim();
                  console.log(
                    "DEBUG tagDiscount ",
                    tagDiscount,
                    " cartDiscount ",
                    cartDiscount
                  );
                  if (tagDiscount === cartDiscount) {
                    // tag matches discount already in cart, nothing more to do
                    bundleTagMatch = tag;
                    break;
                  }
                }
              }
            }

            if (bundleTagMatch) {
              // console.log('DEBUG bundleTagMatch ', bundleTagMatch);
              return; // found matching tag, no action needed
            } else {
              // 7. No matching tag, need to update line item property (_bundle_discount) with the discount coming from the tag or fall back to default discount

              // Find the first matching percent bundle tag as the source of truth
              let correctTag = (bundleProduct.tags || []).find((tag) =>
                /(\d+)-percent-bundle/.test(tag)
              );
              // console.log('DEBUG correctTag ', correctTag, bundleProduct.tags);
              let discountFromTag = window.themeVariables.bundle_discount
                .replace("%", "")
                .trim();
              if (correctTag) {
                discountFromTag = correctTag
                  .replace("-percent-bundle", "")
                  .trim();
              }
              // console.log('DEBUG new discount  ', discountFromTag);

              if (cartDiscount === discountFromTag) {
                return; // discount matches, nothing to do
              }

              // prepare a change for cart/change.js
              let updatedProperties = Object.assign({}, item.properties, {
                _bundle_discount: discountFromTag,
              });

              // API expects null for empty properties
              Object.keys(updatedProperties).forEach((k) => {
                if (
                  updatedProperties[k] === "" ||
                  updatedProperties[k] === undefined
                )
                  updatedProperties[k] = null;
              });

              updatedCart = await (
                await fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: item.quantity,
                    properties: updatedProperties,
                  }),
                })
              ).json();
            }
          }
        }
      }
      if (updatedCart) {
        // console.log('DEBUG updatedCart ', updatedCart);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "line-item:change",
              cart: updatedCart,
            },
          })
        );
      }
    } catch (err) {
      console.error("Error in doubleDiscountCheckInCart", err);
    }
  }
  doubleDiscountCheckInCart();

  // check before procceding to checkout
  window.addEventListener("load", function () {
    if (document.querySelector('cart-drawer form[action="/cart"]')) {
      document
        .querySelector('cart-drawer form[action="/cart"]')
        .addEventListener("submit", async function (e) {
          console.log("DEBUG submit event", e, activeBundleInCart);
          if (activeBundleInCart) {
            e.preventDefault();
            e.stopPropagation();
            console.log(
              "DEBUG activeBundleInCart, double discount check in cart"
            );
            await doubleDiscountCheckInCart();
            window.location = "/checkout";
          }
        });
    }
  });

  document.addEventListener("cart:refresh", async function (e) {
    doubleDiscountCheckInCart();
  });
})();
